import { Routes, Route } from "react-router-dom";

import styles from "../common/Page.module.css";
import SideMenuStatic from "Page/common/SideMenuStatic";
import PortfolioMain from "./Content/PortfolioMain";
import PortfolioBoard from "./Content/PortfolioBoard";
import PortfolioArticle from "./Content/PortfolioArticle";
import Delivery from "./Delivery";
import Outsourcing from "./Outsourcing";

export default function PortfolioPage() {
  const menus = [
    { title: "제품 납품", to: "delivery" },
    { title: "외주 현황", to: "outsourcing" },
  ];

  return (
    <div className={styles.Page}>
      <SideMenuStatic title="포트폴리오" menus={menus} />
      <div className={styles.ContentContainer}>
        <Routes>
          <Route exact path="/" element={<PortfolioMain />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/outsourcing" element={<Outsourcing />} />
          <Route
            path="/delivery/article/:article_id"
            element={<PortfolioArticle category={"제품 납품"} />}
          />
          <Route
            path="/outsourcing/article/:article_id"
            element={<PortfolioArticle category={"외주 현황"} />}
          />
          <Route path="/category/:category_id" element={<PortfolioBoard />} />
          <Route path="/article/:article_id" element={<PortfolioArticle />} />
        </Routes>
      </div>
    </div>
  );
}
